/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAdminResolutionRequestResponse } from './ControlAdminResolutionRequestResponse';
import {
    ControlAdminResolutionRequestResponseFromJSON,
    ControlAdminResolutionRequestResponseFromJSONTyped,
    ControlAdminResolutionRequestResponseToJSON,
} from './ControlAdminResolutionRequestResponse';

/**
 * 
 * @export
 * @interface ControlPaginatedAdminResolutionsResponse
 */
export interface ControlPaginatedAdminResolutionsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminResolutionsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminResolutionsResponse
     */
    page_size: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedAdminResolutionsResponse
     */
    count: number;
    /**
     * 
     * @type {Array<ControlAdminResolutionRequestResponse>}
     * @memberof ControlPaginatedAdminResolutionsResponse
     */
    results: Array<ControlAdminResolutionRequestResponse>;
}

/**
 * Check if a given object implements the ControlPaginatedAdminResolutionsResponse interface.
 */
export function instanceOfControlPaginatedAdminResolutionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedAdminResolutionsResponseFromJSON(json: any): ControlPaginatedAdminResolutionsResponse {
    return ControlPaginatedAdminResolutionsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedAdminResolutionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedAdminResolutionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'page_size': json['page_size'],
        'count': json['count'],
        'results': ((json['results'] as Array<any>).map(ControlAdminResolutionRequestResponseFromJSON)),
    };
}

export function ControlPaginatedAdminResolutionsResponseToJSON(value?: ControlPaginatedAdminResolutionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlAdminResolutionRequestResponseToJSON)),
    };
}

